import { E_ROUTE_OPEN_API_ANALYSIS, E_ROUTE_OPEN_API_CONTENT_CONFIGURABLE, E_ROUTE_OPEN_API_INNO_API } from './route.types';
export default [
    {
        path: '/open-api',
        name: 'openApi',
        redirect: { name: 'openApiMenu' },
        component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/Main.vue'),
        children: [
            {
                path: '/open-api/menu',
                name: 'openApiMenu',
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/menu/Menu.vue'),
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'OpenApi',
                        },
                        {
                            text: 'openapi.menu.title',
                            active: true,
                        }
                    ],
                    permission: 'MenuClassification',
                },
            },
            {
                path: '/open-api/api-maintain',
                name: 'openApiApiMaintain',
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/apiMaintain/ApiMaintain.vue'),
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'OpenApi',
                        },
                        {
                            text: 'backoffice.nav.open_api_maintain',
                            active: true,
                        }
                    ],
                    permission: 'ApiConfig',
                },
            },
            {
                path: '/open-api/api-file-maintain',
                name: 'openApiApiFileMaintain',
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/apiFileMaintain/ApiFileMaintain.vue'),
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'OpenApi',
                        },
                        {
                            text: 'backoffice.nav.open_api_file_maintain',
                            active: true,
                        }
                    ],
                    permission: 'ApiConfig',
                },
            },
            {
                path: '/open-api/whitelist',
                name: 'openApiApiWhitelist',
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/whitelist/Whitelist.vue'),
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'OpenApi',
                        },
                        {
                            text: 'backoffice.nav.open_api_whitelist',
                            active: true,
                        }
                    ],
                    permission: 'ApiWhitelist',
                },
            },
            {
                path: '/open-api/package',
                name: 'openApiApiPackage',
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/package/Package.vue'),
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'OpenApi',
                        },
                        {
                            text: 'backoffice.nav.open_api_package',
                            active: true,
                        }
                    ],
                    permission: 'ProductPackageManagement',
                },
            },
            // 套餐额度分配
            {
                path: '/open-api/quota',
                name: 'openApiApiQuotaDistribution',
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/PackageQuotaDistribution/PackageQuotaDistribution.vue'),
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'OpenApi',
                        },
                        {
                            text: 'backoffice.nav.open_api_quota_distribution',
                            active: true,
                        }
                    ],
                    permission: 'ProductPackageManagement',
                },
            },
            {
                path: '/open-api/analysis',
                name: E_ROUTE_OPEN_API_ANALYSIS.OPENAPIANALYSIS,
                redirect: {
                    name: E_ROUTE_OPEN_API_ANALYSIS.OPENAPIMONTHLYBILL,
                },
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/Analysis/OpenAPIAnalysis/OpenAPIAnalysis.vue'),
                children: [
                    {
                        name: E_ROUTE_OPEN_API_ANALYSIS.OPENAPIMONTHLYBILL,
                        path: '/open-api/monthly-bill',
                        component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/Analysis/MonthlyBill/MonthlyBill.vue'),
                        props: true,
                        meta: {
                            keepAlive: false,
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operation_tool',
                                },
                                {
                                    text: 'OpenApi',
                                },
                                {
                                    text: 'backoffice.nav.open_api_analysis',
                                },
                                {
                                    text: 'backoffice.nav.open_api_monthly_bill',
                                    active: true,
                                }
                            ],
                            permission: 'MonthlyBill',
                        },
                    },
                    {
                        name: E_ROUTE_OPEN_API_ANALYSIS.OPENAPIPACKAGEUSAGE,
                        path: '/open-api/package-usage',
                        component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/Analysis/PackageUsage/PackageUsage.vue'),
                        props: true,
                        meta: {
                            keepAlive: false,
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operation_tool',
                                },
                                {
                                    text: 'OpenApi',
                                },
                                {
                                    text: 'backoffice.nav.open_api_analysis',
                                },
                                {
                                    text: 'backoffice.nav.open_api_package_usage',
                                    active: true,
                                }
                            ],
                            permission: 'PackageUsage',
                        },
                    },
                    {
                        name: E_ROUTE_OPEN_API_ANALYSIS.OPENAPICUSTOMERUSAGERANKING,
                        path: '/open-api/customer-usage-ranking',
                        component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/Analysis/CustomerUsageRanking/CustomerUsageRanking.vue'),
                        props: true,
                        meta: {
                            keepAlive: false,
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operation_tool',
                                },
                                {
                                    text: 'OpenApi',
                                },
                                {
                                    text: 'backoffice.nav.open_api_analysis',
                                },
                                {
                                    text: 'backoffice.nav.open_api_customer_usage_ranking',
                                    active: true,
                                }
                            ],
                            permission: 'CustomerUsageRanking',
                        },
                    },
                    {
                        name: E_ROUTE_OPEN_API_ANALYSIS.OPENAPIPACKAGEUSAGERANKING,
                        path: '/open-api/package-usage-ranking',
                        component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/Analysis/PackeageUsageRanking/PackeageUsageRanking.vue'),
                        props: true,
                        meta: {
                            keepAlive: false,
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operation_tool',
                                },
                                {
                                    text: 'OpenApi',
                                },
                                {
                                    text: 'backoffice.nav.open_api_analysis',
                                },
                                {
                                    text: 'backoffice.nav.open_api_package_usage_ranking',
                                    active: true,
                                }
                            ],
                            permission: 'PackeageUsageRanking',
                        },
                    },
                    {
                        name: E_ROUTE_OPEN_API_ANALYSIS.OPENAPIAPIUSAGERANKING,
                        path: '/open-api/api-usage-ranking',
                        component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/Analysis/APIUsageRanking/APIUsageRanking.vue'),
                        props: true,
                        meta: {
                            keepAlive: false,
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operation_tool',
                                },
                                {
                                    text: 'OpenApi',
                                },
                                {
                                    text: 'backoffice.nav.open_api_analysis',
                                },
                                {
                                    text: 'backoffice.nav.open_api_api_usage_ranking',
                                    active: true,
                                }
                            ],
                            permission: 'APIUsageRanking',
                        },
                    }
                ],
            },
            {
                path: '/open-api/content-configurable',
                name: E_ROUTE_OPEN_API_CONTENT_CONFIGURABLE.OPENAPI_CONTENT_CONFIGURABLE,
                redirect: {
                    name: E_ROUTE_OPEN_API_CONTENT_CONFIGURABLE.OPENAPI_CONTENT_CONFIGURABLE_INDEX,
                },
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/ContentConfigurable/ContentConfigurable.vue'),
                children: [
                    {
                        name: E_ROUTE_OPEN_API_CONTENT_CONFIGURABLE.OPENAPI_CONTENT_CONFIGURABLE_INDEX,
                        path: '/open-api/content-configurable-index',
                        component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/ContentConfigurable/children/Index/ContentConfigurableIndex.vue'),
                        props: true,
                        meta: {
                            keepAlive: false,
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operation_tool',
                                },
                                {
                                    text: 'OpenApi',
                                },
                                {
                                    text: 'backoffice.nav.open_api_content_configurable',
                                },
                                {
                                    text: 'backoffice.nav.open_api_content_configurable_index',
                                    active: true,
                                }
                            ],
                            permission: 'ContentConfigurableIndex',
                        },
                    },
                    {
                        name: E_ROUTE_OPEN_API_CONTENT_CONFIGURABLE.OPENAPI_CONTENT_CONFIGURABLE_SOLUTION_GROUP,
                        path: '/open-api/content-configurable-solution-group',
                        component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/ContentConfigurable/children/SolutionGroup/ContentConfigurableSolutionGroup.vue'),
                        props: true,
                        meta: {
                            keepAlive: false,
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operation_tool',
                                },
                                {
                                    text: 'OpenApi',
                                },
                                {
                                    text: 'backoffice.nav.open_api_content_configurable',
                                },
                                {
                                    text: 'backoffice.nav.open_api_content_configurable_solution_group',
                                    active: true,
                                }
                            ],
                            permission: 'ContentConfigurableSolutionGroup',
                        },
                    },
                    {
                        name: E_ROUTE_OPEN_API_CONTENT_CONFIGURABLE.OPENAPI_CONTENT_CONFIGURABLE_SOLUTION,
                        path: '/open-api/content-configurable-solution',
                        component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/ContentConfigurable/children/Solution/ContentConfigurableSolution.vue'),
                        props: true,
                        meta: {
                            keepAlive: false,
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operation_tool',
                                },
                                {
                                    text: 'OpenApi',
                                },
                                {
                                    text: 'backoffice.nav.open_api_content_configurable',
                                },
                                {
                                    text: 'backoffice.nav.open_api_content_configurable_solution',
                                    active: true,
                                }
                            ],
                            permission: 'ContentConfigurableSolution',
                        },
                    },
                    {
                        name: E_ROUTE_OPEN_API_CONTENT_CONFIGURABLE.OPENAPI_CONTENT_CONFIGURABLE_DATA_PACKAGE,
                        path: '/open-api/content-configurable-data-package',
                        component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/ContentConfigurable/children/DataPackage/ContentConfigurableDataPackage.vue'),
                        props: true,
                        meta: {
                            keepAlive: false,
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operation_tool',
                                },
                                {
                                    text: 'OpenApi',
                                },
                                {
                                    text: 'backoffice.nav.open_api_content_configurable',
                                },
                                {
                                    text: 'backoffice.nav.open_api_content_configurable_data_package',
                                    active: true,
                                }
                            ],
                            permission: 'ContentConfigurableDataPackage',
                        },
                    }
                ],
            },
            // INNO套餐key管理
            {
                name: E_ROUTE_OPEN_API_INNO_API.OPENAPI_INNO_API,
                path: '/open-api/key',
                redirect: {
                    name: E_ROUTE_OPEN_API_INNO_API.OPENAPI_INNO_API_MANAGEMENT,
                },
                component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/inno-key/InnoKey.vue'),
                children: [{
                        name: E_ROUTE_OPEN_API_INNO_API.OPENAPI_INNO_API_MANAGEMENT,
                        path: '/open-api/key-management',
                        component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/inno-key/key-management/KeyManagement.vue'),
                        props: true,
                        meta: {
                            keepAlive: false,
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operation_tool',
                                },
                                {
                                    text: 'OpenApi',
                                },
                                {
                                    text: 'backoffice.nav.open_api_key_management',
                                },
                                {
                                    text: 'backoffice.nav.open_api_key_api',
                                    active: true,
                                }
                            ],
                            permission: 'Analysis',
                        },
                    }, {
                        name: E_ROUTE_OPEN_API_INNO_API.OPENAPI_INNO_API_RECHARGE,
                        path: '/open-api/key-recharge-record',
                        component: () => import(/* webpackChunkName: "open_api" */ '@/views/openApi/inno-key/recharge-record/RechargeRecord.vue'),
                        props: route => ({ query: route.query }),
                        meta: {
                            keepAlive: false,
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.operation_tool',
                                },
                                {
                                    text: 'OpenApi',
                                },
                                {
                                    text: 'backoffice.nav.open_api_key_management',
                                },
                                {
                                    text: 'backoffice.nav.open_api_key_recharge_record',
                                    active: true,
                                }
                            ],
                            permission: 'Analysis',
                        },
                    }],
            }
        ],
    }
];
